import { lazy } from 'react'
import MenusLoader from './loader'
import ViewMenuLoader from './view/loader'
import CreateMenuLoader from './create/loader'

export default {
  Menus: {
    Component: lazy(() => import('./Menus.Page')),
    Loader: MenusLoader,
  },
  ViewMenu: {
    Component: lazy(() => import('./view/ViewMenu.Page')),
    Loader: ViewMenuLoader,
  },
  CreateMenu: {
    Component: lazy(() => import('./create/CreateMenu.Page')),
    Loader: CreateMenuLoader,
  },
}
